import {webRequest, webNoTokenRequest} from '../api'

// 上傳影片
export function uploadVideo(data) {
    return webRequest({
        url:'/oauth/house/manage/case/houseFilm',
        method:'post',
        data: data,
    })
}


// WEBPACK FOOTER //
// ./src/apis/landlord/houseMgt.js